import {
  FormActionsMui,
  FormActionsMuiRenderContainer,
} from '@app/components/form/actions/FormActionsMui';
import { useBreakpointsDown } from '@app/core/hooks/useBreakpointsDown';
import { Box } from '@mui/material';

/** Form actions for the create-fragment panel, all aligned to the right. */
const fragmentActionsLayout: FormActionsMuiRenderContainer = (
  leftActions,
  rightActions,
  { actionsWrap } = {},
) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 2,
      ...(actionsWrap && { flexWrap: 'wrap' }),
    }}
  >
    {leftActions}
    {rightActions}
  </Box>
);

type FragmentFormActionsProps = Parameters<typeof FormActionsMui>[0];

/** Form actions component for the fragment creation panel. */
export function FragmentFormActions(props: FragmentFormActionsProps) {
  const { isXl } = useBreakpointsDown();

  return (
    <FormActionsMui
      variant={isXl ? 'compact' : 'default'}
      {...props}
      actionsWrap
      renderContainer={fragmentActionsLayout}
      marginTop={0}
    />
  );
}
